import { useState, useEffect } from 'react'
import styles from './css/sidebar.module.css'
import credit from "../images/credit.png";
import MapIcon from '@mui/icons-material/Map';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DomainIcon from '@material-ui/icons/Domain';
import DescriptionIcon from '@mui/icons-material/Description';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import SettingsIcon from '@mui/icons-material/Settings';
import MenuIcon from '@mui/icons-material/Menu';


export default function Sidebar(props) {
    const [showsidebar, setShowsidebar] = useState(false);  
    const [showsites, setShowsites] = useState(false);
    const [showedits, setShowedits] = useState(false);
    const [sites, setSites] = useState([]);

    useEffect(() => {
        if (props.sites.length > 0) {
            setSites(props.sites);
        }
    }, [props.sites]);

    useEffect(() => {
        sortPoints();
    }, [sites]);

    function sortPoints() {
        function diff(a, b) {
            if (a === b) return 0
            else if (a == null) return 1
            else if (b == null) return -1
            else return a < b ? 1 : -1;
        }
        sites.sort((a, b) => diff(a.latitude, b.latitude));
    }

    return (
        <>
        {(showsidebar || props.small) &&
        <div className={styles.Sidebar}>
            <>
            <ul className={styles.SidebarList}>
                <li className={styles.row} onClick={() => {setShowsidebar(false);props.menuselect({menu:"map",site:""});}}>
                    <div id={styles.icon}><MapIcon /></div>
                    <div id={styles.title}>マップ</div>
                </li>
                <li className={styles.row} onClick={() => {setShowsidebar(false);props.menuselect({menu:"dashboard",site:""});}}>
                    <div id={styles.icon}><DashboardIcon /></div>
                    <div id={styles.title}>ダッシュボード</div>
                </li>
                <li className={styles.row} onClick={() => {setShowsites(!showsites)}}>
                    <div id={styles.icon}><DomainIcon /></div>
                    <div id={styles.title}>各建物データ</div>
                </li>
                {props.sites.map((value, key) => {
                    return (
                        showsites ? (
                            <li key={key} className={styles.row} style={{ height: "36px" }} onClick={() => {setShowsidebar(false);props.menuselect({menu:"site",site:value.name}); }}>
                                <div id={styles.point} title={value.name}>{value.name}</div>
                            </li>
                        ) : <div key={key} hidden/>
                    )
                })}
                <li className={styles.row} onClick={() => {setShowsidebar(false);props.menuselect({menu:"guide",site:""})}}>
                    <div id={styles.icon}><DescriptionIcon /></div>
                    <div id={styles.title}>システム概要</div>
                </li>
                <li className={styles.row} onClick={() => {setShowsidebar(false);props.menuselect({menu:"support",site:""})}}>
                    <div id={styles.icon}><ContactSupportIcon /></div>
                    <div id={styles.title}>サポート</div>
                </li>
                { props.admin > 0 && <>
                <li className={styles.row} onClick={() => {setShowedits(!showedits)}}>
                    <div id={styles.icon}><SettingsIcon /></div>
                    <div id={styles.title}>各建物設定</div>
                </li>
                {props.sites.map((value, key) => {
                    return (
                        showedits > 0 ? (
                            <li key={key} className={styles.row} style={{ height: "36px" }} onClick={() => {setShowsidebar(false);props.menuselect({menu:"edit",site:value.name}); }}>
                                <div id={styles.point} title={value.name}>{value.name}</div>
                            </li>
                        ) : <div key={key} hidden/>
                    )
                })}
                </>}
            </ul>
            </>
            <div style={{ position: "absolute", bottom: 0 }}>
                <a href="https://knowledgeforesight.com/">
                    <img src={credit} alt="Knowledgeforesight" height='auto' width='200px' style={{ verticalAlign: "bottom" }} />
                </a>
            </div>
        </div>
        }
        {! props.small && <div className={styles.menu} onClick={()=>setShowsidebar(!showsidebar)}><MenuIcon /></div>}
        </>
    )
}



